(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cant_seem_find_my_tail_banner"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("agreeCheck-left");
    const button = document.getElementById("quickShopBtn-left");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cant_seem_physical_book"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("agreeCheck-right");
    const button = document.getElementById("quickShopBtn-right");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["every_day_hero_mp3_song"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("agreeCheck-left");
    const button = document.getElementById("quickShopBtn-left");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });

  document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("agreeCheck-right");
    const button = document.getElementById("quickShopBtn-right");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["everyday_hero_virtual_story_banner"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("agreeCheck-story");
    const button = document.getElementById("quickShopBtn-story");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["i-can-t-seem-every-day-hero-mp3-song-pansie_blues"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("agreeCheck-left");
    const button = document.getElementById("quickShopBtn-left");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });

  document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("agreeCheck-right");
    const button = document.getElementById("quickShopBtn-right");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["i-can-t-seem-to-find-my-tail-pansie-blues"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("agreeCheck-story");
    const button = document.getElementById("quickShopBtn-story");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["i-can-t-seem-to-find-my-tail"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("agreeCheck-story");
    const button = document.getElementById("quickShopBtn-story");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["i-can-t-seem_every_day_hero_mp3_song"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("agreeCheck-left");
    const button = document.getElementById("quickShopBtn-left");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });

  document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("agreeCheck-right");
    const button = document.getElementById("quickShopBtn-right");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["i_wanna_be_purrfect_banner"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("showCatvirtualStory");
    const button = document.getElementById("showCatvirtualStory-btn");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["i_wanna_be_purrfect_book"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

    const checkbox = document.getElementById("physicalBookaction");
    const button = document.getElementById("physicalBookbtn");

    checkbox.addEventListener("change", function () {

        if (this.checked) {
            button.classList.add("active");
            console.log("active added");
        } else {
            button.classList.remove("active");
            console.log("active removed");
        }

    });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["little_shop_wonder_banner"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("agreeCheck-left");
    const button = document.getElementById("quickShopBtn-left");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["little_shop_wonder_book"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("agreeCheck-right");
    const button = document.getElementById("quickShopBtn-right");

    checkbox.addEventListener("change", function() {
      if (this.checked) {
        button.disabled = false;
        button.classList.add("active");
      } else {
        button.disabled = true;
        button.classList.remove("active");
      }
    });
  });


  } catch(e) { console.error(e); }
})();
})();
